import transform from '../../../utils/ResponseTransformator'
import { IData } from '../fetchProvenances'
import mapResponseToProvenance from '../mappers/mapResponseToProvenance'

export default async function(response: Response) {
  let text: string = await response.text()
  text = transform(text)
  const json: IData = JSON.parse(text)

  return mapResponseToProvenance(json)
}
